import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getListingGroupDetails } from '@bingads-webui-campaign-react/wizard-shared-components';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const ListingGroup = ({ data }) => {
  const i18n = useContext(I18nContext);

  const {
    productFilter,
    listingGroup,
  } = data || {};

  const listingGroupDetails = useMemo(() => getListingGroupDetails(
    i18n,
    !!productFilter,
    {
      productFilter,
      listingGroup,
    }
  ), [i18n, listingGroup, productFilter]);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Listing group') }}>
      <div>{listingGroupDetails}</div>
    </PropertyRow>
  );
};

ListingGroup.propTypes = {
  data: PropTypes.shape({
    listingGroup: PropTypes.shape({}),
    productFilter: PropTypes.shape({}),
  }).isRequired,
};
